import { createChannel, createClient } from 'nice-grpc-web';
import { DEV_ENDPOINT } from '@/api/common';
import { api, notification } from '@zentrains/api';

const devChannel = createChannel(DEV_ENDPOINT);
export const devApi: api.v3.ZenTrainsClient = createClient(api.v3.ZenTrainsDefinition, devChannel);
export const devNotificationApi: notification.v3.NotificationClient = createClient(
  notification.v3.NotificationDefinition,
  devChannel,
);
